// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_42-7";
export var adjustableWidthBorderHeld = "_42-8";
export var arrow = "_42-3";
export var arrowButton = "_42-4";
export var headerCell = "_42-0";
export var help = "_42-2";
export var icon = "_42-1";
export var iconWrapper = "_42-6";
export var noBorder = "_42-b";
export var nonAdjustableWidthBorder = "_42-9";
export var nonAdjustableWidthBorderHeld = "_42-a";
export var textButton = "_42-5";